export const adaptCourseTypeText = (course: string) => {
  if (course?.toLowerCase() === 'percorsi' || course?.toLowerCase() === 'percorso')
    return 'Percorso';
  return course;
};
